
window.getCart = async function()
{
  return fetch(window.Shopify.routes.root + 'cart/update.js').then(res => res.json()).catch(() => null);
}

window.updateCart = function(updates)
{
  return fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates })
  }).then(res => res.json()).catch(() => null);
}

window.getSections = async function(sections)
{
  return fetch('/?sections='+sections.join(',')).then(res => res.json()).catch(() => null);
}

window.drawer_postChangeCart = function(newCart, scroll)
{

  let updateSections = ["cart-drawer", "cart-icon-bubble", "cart-icon-bubble-mobile"];
  return getSections(updateSections).then(sections => {
    let cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    for (const item of newCart.items)
    {
      item.sections = sections;
      cart.renderContents(item);
      executeScripts(cart);
    }
    cart.open();
    let items = document.querySelector("cart-drawer-items");
    items.scroll(0, scroll)
    setTimeout(() => items.scroll(0, scroll), 0);
    
  });
  
}

window.drawer_updateItem = function(item, input, qnt)
{
  const updates = {};
  updates[item] = parseInt(input.value) + qnt;
  input.value = updates[item].toString();
  let scroll = document.querySelector("cart-drawer-items").scrollTop;
  updateCart(updates).then(cart => drawer_postChangeCart(cart, scroll));
}

window.executeScripts = function(elm) {
  Array.from(elm.querySelectorAll("script"))
    .forEach( oldScriptEl => {
      const newScriptEl = document.createElement("script");
      
      Array.from(oldScriptEl.attributes).forEach( attr => {
        newScriptEl.setAttribute(attr.name, attr.value) 
      });
      
      const scriptText = document.createTextNode(oldScriptEl.innerHTML);
      newScriptEl.appendChild(scriptText);
      
      oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
  });
}

window.multiVariantSet = function(prefix, item, val)
{
  const qnt = document.getElementById(`${prefix}_${item}_qnt`);
  if (!qnt) return;
  const qntmb = document.getElementById(`${prefix}_${item}_qntmb`);
  const less = document.getElementById(`${prefix}_${item}_less`);
  const name = document.getElementById(`${prefix}_${item}_name`);
  const inCart = eval(`${ prefix }_cart.items[${item}]??0`);
  qnt.innerHTML = val;
  qntmb.innerHTML = val;
  if (val > 0 && qntmb.classList.contains("nosel"))
  {
    qntmb.classList.remove("nosel");
    name.classList.remove("nosel");
    less.classList.remove("nosel");
  }
  else if (val == 0 && !qntmb.classList.contains("nosel"))
  {
    qntmb.classList.add("nosel");
    name.classList.add("nosel");
    less.classList.add("nosel");
  }
  eval(`${prefix}_refreshTotal()`);
}

window.multiVariantAddTimeout = {};

window.multiVariantAdd = function(prefix, item, max, doCheck = true)
{
  //getCart().then(res => {
    //eval(`${prefix}_updateCartVar(res.items)`);
    const qnt = document.getElementById(`${prefix}_${item}_qnt`);
    const inCart = eval(`${ prefix }_cart.items[${item}]??0`);
    let val = parseInt(qnt.innerHTML) + inCart + 1;
    if (val >= max && !doCheck)
    {
      val = max;
      // DISPONIBILITA MASSIMA
      const popup = document.getElementById(`${prefix}_${item}_popup`);
      const mpopup = document.getElementById(`${prefix}_${item}_mpopup`);
      mpopup.style.display = popup.style.display = 'block';
      setTimeout(() => {
        mpopup.style.display = popup.style.display = 'none';
      }, 3000);
    }
    val = (val > max ? max : val);
    eval(`${prefix}_set[${item}] = ${val}`);
    multiVariantSet(prefix, item, val-inCart);
    val = parseInt(qnt.innerHTML);
    if (doCheck)
    {
      if (prefix in multiVariantAddTimeout)
        clearTimeout(multiVariantAddTimeout[prefix]);
      multiVariantAddTimeout[prefix] = setTimeout(() => {
        getCart().then(res => {
          eval(`${prefix}_updateCartVar(res.items)`);
          multiVariantRemove(prefix, item);
          multiVariantAdd(prefix, item, max, false);
        });
      }, 500);
    }
  //});
  
}

window.multiVariantRemove = function(prefix, item)
{
  const qnt = document.getElementById(`${prefix}_${item}_qnt`);
  let val = parseInt(qnt.innerHTML) - 1;
  if (val < 0) return;
  eval(`${prefix}_set[${item}] = ${val}`);
  multiVariantSet(prefix, item, val);
  val = parseInt(qnt.innerHTML);
}

window.rgbToHsl = function(rgb)
{
  const parsedColor = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(rgb);
  const color = parsedColor ? {
    r: parseInt(parsedColor[1], 16),
    g: parseInt(parsedColor[2], 16),
    b: parseInt(parsedColor[3], 16)
  } : null;
  if (!color)
    return null;
  const r = color.r / 255;
  const g = color.g / 255;
  const b = color.b / 255;
  const M = Math.max(r,g,b);
  const m = Math.min(r,g,b);
  const d = M-m;
  let h, s, l;
  if( d==0 ) h=0;
  else if( M==r ) h=((g-b)/d)%6;
  else if( M==g ) h=(b-r)/d+2;
  else h=(r-g)/d+4;
  h*=60;
  if( h<0 ) h+=360;
  l = (M+m)/2;
  if( d==0 )
      s = 0;
  else
      s = d/(1-Math.abs(2*l-1));
  s*=100;
  l*=100;
  return { h, s, l };
}


console.log("webgain.js loaded");